import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../../utils/style.js';
import { BlockWrapper } from '../BlockWrapper.js';
import { Heading } from '../Heading/Heading.js';
export const CalculatorLayout = JSX(({ className, title, children, ...rest }) => (_jsxs(BlockWrapper, { className: style('space-y-xl', className), defaultPadding: "p-4xl", ...rest, children: [title ? _jsx(Heading, { className: "text-center", title: title }) : null, children] })));
//# sourceMappingURL=CalculatorLayout.js.map